<template>
    <div>
        <limitless-page-header :title="'Produktikoner'">
            <template #header-elements>
                <limitless-page-header-button url="/product_icons/0" icon="icon-plus3">Ny ikon</limitless-page-header-button>
            </template>
        </limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/product_icons'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" sort-by="Category" sort-order="asc" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control" placeholder="Sök...">
                    </div>
                </div>
                <template #cell_Url="{ row }">
                    <img :src="row.Url" :alt="row.IconText" style="max-width: 43px; max-width: 43px;">
                </template>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Layout/partials/LimitlessPageHeader';
import LimitlessPageHeaderButton from '@components/Layout/partials/LimitlessPageHeaderButton';
import RednaxDatatable from '@components/Datatable/RednaxDatatableComponent';

export default {
    name: 'ProductIconList',
    components: {
        LimitlessPageHeader,
        LimitlessPageHeaderButton,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            per_page: 25,
        },
        table_columns: [
            {
                header: '#',
                data: 'IconID',
                sortable: true,
            },
            {
                header: 'Ikon',
                data: 'Url',
                sortable: false,
            },
            {
                header: 'Namn',
                data: 'IconText',
                sortable: true,
            },
            {
                header: 'Kategori',
                data: 'Category',
                sortable: true,
            },
        ],
    }),
    methods: {
        rowClick(row, event) {
            if (event.metaKey === true || event.ctrlKey === true) {
                window.open('/product_icons/' + row.IconID).focus();
            } else {
                this.$router.push({ name: 'producticons.edit', params: { id: row.IconID } });
            }
        },
    },
};

</script>
